/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AcademyCategoryIcon {
  binders = "binders",
  bookWithStar = "bookWithStar",
  cogs = "cogs",
  document = "document",
  employeeBadge = "employeeBadge",
  film = "film",
  text = "text",
  textVideo = "textVideo",
  transaction = "transaction",
}

export enum AcademyCustomerCategory {
  free = "free",
  paid = "paid",
}

export enum AcademyTarget {
  ios = "ios",
  public = "public",
  sumify = "sumify",
}

export enum AccountingOnboardingSyncedPreOfferBank {
  handelsbankenCompany = "handelsbankenCompany",
  lfBank = "lfBank",
  nordea = "nordea",
  sebCompany = "sebCompany",
  swedbankCompany = "swedbankCompany",
}

export enum AccountingOnboardingSyncedPreOfferStatus {
  bankSynced = "bankSynced",
  businessInfoDone = "businessInfoDone",
  done = "done",
  fetchAccountsDone = "fetchAccountsDone",
  notStarted = "notStarted",
  organizationSummarySynced = "organizationSummarySynced",
  pendingBankSync = "pendingBankSync",
  pendingOrganizationSummarySync = "pendingOrganizationSummarySync",
  rejected = "rejected",
  syncFailed = "syncFailed",
}

/**
 * See https: // www.bankid.com/assets/bankid/rp/bankid-relying-party-guidelines-v3.2.1.pdf for BankID recommended messages
 */
export enum BankIdOrderHintCode {
  cancelled = "cancelled",
  certificateErr = "certificateErr",
  expiredTransaction = "expiredTransaction",
  noClient = "noClient",
  outstandingTransaction = "outstandingTransaction",
  startFailed = "startFailed",
  started = "started",
  userCancel = "userCancel",
  userSign = "userSign",
}

export enum BankIdOrderStatus {
  complete = "complete",
  failed = "failed",
  pending = "pending",
}

export enum DooerPriceGridServiceUnit {
  monthly = "monthly",
  oneTime = "oneTime",
}

export enum IbSessionStatus {
  done = "done",
  failed = "failed",
  partiallyFailed = "partiallyFailed",
  pending = "pending",
  processing = "processing",
  waitingForBankid = "waitingForBankid",
}

export enum InstitutionKey {
  bankgiro = "bankgiro",
  handelsbankenCompany = "handelsbankenCompany",
  lfBank = "lfBank",
  manual = "manual",
  mockBank = "mockBank",
  mockSkatteverket = "mockSkatteverket",
  nordea = "nordea",
  paypal = "paypal",
  sebCompany = "sebCompany",
  skatteverket = "skatteverket",
  swedbank = "swedbank",
  swedbankCompany = "swedbankCompany",
  swedbankEntercardCompany = "swedbankEntercardCompany",
  swedbankPersonal = "swedbankPersonal",
}

export enum OrderOrganizationStatus {
  active = "active",
  new = "new",
  notStarted = "notStarted",
}

export enum OrderOrganizationType {
  AB = "AB",
  EF = "EF",
  HB = "HB",
  OTHER = "OTHER",
}

/**
 * Deprecated
 */
export enum Platform {
  android = "android",
  ios = "ios",
  web = "web",
}

export interface AccountingOnboardingContactInput {
  firstName?: string | null;
  lastName?: string | null;
  role?: string | null;
  email?: string | null;
  phone?: string | null;
}

export interface AccountingOnboardingInput {
  organizationInfo?: AccountingOnboardingOrganizationInput | null;
  contactsInfo?: AccountingOnboardingContactInput[] | null;
  tags?: string[] | null;
}

export interface AccountingOnboardingOrganizationInput {
  organizationNumber?: string | null;
  name?: string | null;
  businessDescription?: string | null;
  sniCodes?: string[] | null;
  fiscalYearEnd?: DooerDate | null;
  yearlyRevenue?: DooerAmount | null;
  registrationDate?: DooerDate | null;
  branch?: string | null;
  bank?: string | null;
}

export interface AccountingOnboardingSyncedPreOfferPostInput {
  idNumber: DooerSwedishPersonalIdentificationNumber;
  ownerEmail?: string | null;
  organizationNumber?: string | null;
  bankInstitution?: AccountingOnboardingSyncedPreOfferBank | null;
  status?: AccountingOnboardingSyncedPreOfferStatus | null;
  storeToken?: boolean | null;
  expiresAt?: DooerDate | null;
}

export interface ConsultantInput {
  name: string;
  email: string;
  phone: string;
  city: string;
  companyName: string;
  consultantCategoryIds: (string | null)[];
}

export interface FeedbackResultInput {
  feedbackQuestionId?: string | null;
  organizationId?: string | null;
  userId?: string | null;
  score?: number | null;
  feedback?: string | null;
}

export interface OrderContactInput {
  name?: string | null;
  email: string;
  phone?: string | null;
}

export interface OrderInput {
  organizationId?: string | null;
  tags?: string[] | null;
  contact: OrderContactInput;
  organization: OrderOrganizationInput;
  package?: OrderPackageInput | null;
}

export interface OrderOrganizationInput {
  seOrganizationNumber?: string | null;
  name: string;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  employees?: number | null;
  revenueRange?: number[] | null;
  desc?: string | null;
  bank?: string | null;
  branch?: string | null;
  status?: OrderOrganizationStatus | null;
  type?: OrderOrganizationType | null;
}

export interface OrderPackageInput {
  name: string;
  details: string;
  price: number;
  campaignPrice: number;
}

export interface SignupInput {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  cellPhone?: string | null;
  companyName: string;
  organizationNumber?: string | null;
  apps?: (string | null)[] | null;
  turnoverLimit?: number | null;
  verificationLimit?: number | null;
  services?: (SmallPriceGridService | null)[] | null;
  branch?: string | null;
  bank?: string | null;
}

export interface SignupTemporaryAccountInput {
  companyName: string;
}

export interface SmallPriceGridService {
  itemId: string;
  price?: number | null;
  discountAmount?: number | null;
  unit?: string | null;
  name?: string | null;
  description?: string | null;
}

export interface UserPatch {
  sePersonnummer?: DooerSwedishPersonalIdentificationNumber | null;
  firstName?: string | null;
  lastName?: string | null;
  language?: DooerLanguageTag | null;
  timeZone?: DooerTimeZone | null;
  isInactivated?: boolean | null;
  email?: string | null;
  phone?: string | null;
  cellPhone?: string | null;
  conversationEmailAddress?: string | null;
  conversationEmailName?: string | null;
  conversationEmailSignature?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
